import { ConvexReactClient } from "convex/react";

const convexUrl = import.meta.env.VITE_CONVEX_URL ?? "https://quiet-tapir-450.convex.cloud";
export const convexClient = new ConvexReactClient(convexUrl);
